<template>
  <div class="banner">
    <div class="banner-text">
      <h1 class="display-text">{{ name.first }} {{ name.last }}</h1>
      <h2 id="typewriter">Software Engineer</h2>
    </div>
  </div>
</template>

<script>
import data from "../../data/data.json";

export default {
  name: "Banner",
  data() {
    return {
      name: data.main.name,
      titles: data.main.titles,
    };
  },
};
</script>

<style lang="scss"></style>
